import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpDeleteServicePhotoOptions,
	httpDeleteServicePhoto
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useDeleteServicePhotos = (
	urlParams: Omit<HttpDeleteServicePhotoOptions, 'mediaId'>,
	options?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			{ mediaId: HttpDeleteServicePhotoOptions['mediaId'] }
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: ({ mediaId }) =>
			httpDeleteServicePhoto({ ...urlParams, mediaId }),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: async (data, variables, onMutateResult, context) => {
			await queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_GALLERY_IMAGES]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
